export class ExpensePeriod {
    start: {
        year: number,
        month: number,
        day: number
    };
    end: {
        year: number,
        month: number,
        day: number
    };
    targetBudget: number;
    id: number;
    constructor(data) {
        this.start = data.start;
        this.end = data.end;
        this.targetBudget = data.targetBudget;
        this.id = data.id;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/expense/expense-reriod.ts